import { useReducer, useCallback } from "react";

import { FiltersReducer } from "../context/FiltersReducer";

export const filtersInitialState = {
    titulo: '',
    tags: '',
    rubros: [],
    subRubros: [],
    grupoArticulos: []
}

export const useFilters = () => {
    const [state, dispatch] = useReducer(FiltersReducer, filtersInitialState)

    const addOrRemoveSubrubro = useCallback((idsubrubro) => {
        const exists = state.subRubros.includes(idsubrubro)
        dispatch({
            type: exists ? 'removeSubrubro' : 'addSubrubro',
            payload: idsubrubro
        })
    }, [state.subRubros]) 

    const removeSubrubro = useCallback((idsubrubro) => {
        dispatch({ type: 'removeSubrubro', payload: idsubrubro })
    }, [])

    const addTitulo = useCallback((word) => {
        dispatch({ type: 'addTitulo', payload: word })
    }, [])

    const removeTitulo = useCallback(() => {
        dispatch({ type: 'removeTitulo' })
    }, [])

    const isSubrubroSelected = useCallback((idsubrubro) =>
        state.subRubros.includes(idsubrubro)
        , [state.subRubros])
    return {
        state,
        addOrRemoveSubrubro,
        removeSubrubro,
        isSubrubroSelected,
        addTitulo,
        removeTitulo
    }
}